import { hotelTraining } from '@/mocks/advancedCourseData';
import { useTranslation } from 'react-i18next';

const DETAIL_COUNT = 3;
const detailIndices = Array.from({ length: DETAIL_COUNT }, (_, i) => i);

export default function HotelTraining() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-primary-900 overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent-500/[0.03] rounded-full translate-x-1/3 -translate-y-1/3 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent-500/[0.02] rounded-full -translate-x-1/3 translate-y-1/3 blur-3xl"></div>

      <div className="relative z-10 max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-14">
          {String(t('coursesAdvanced.hotelTraining.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-400/60 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-4">
            {t('coursesAdvanced.hotelTraining.title')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {String(t('coursesAdvanced.hotelTraining.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-400/50 text-sm tracking-[0.12em] mb-4">{__s}</p>))}
          {String(t('coursesAdvanced.hotelTraining.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[17px] text-foreground-300 leading-relaxed tracking-[0.04em] max-w-xl mx-auto">{__s}</p>))}
        </div>

        {/* Details */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
          {detailIndices.map((index) => (
            <div
              key={index}
              className="text-center p-6 border border-white/10 bg-white/[0.03] group hover:border-accent-500/30 hover:bg-accent-500/[0.04] transition-all duration-300"
            >
              <span className="w-10 h-10 mx-auto mb-4 flex items-center justify-center">
                <i className={`${hotelTraining.details[index]?.icon} text-accent-400 text-xl group-hover:text-accent-300 transition-colors duration-300`}></i>
              </span>
              <p className="text-[13px] text-accent-400/60 tracking-[0.12em] mb-2 font-label">
                {t(`coursesAdvanced.hotelTraining.${index}.title`)}
              </p>
              <p className="text-[16px] text-foreground-300 tracking-[0.04em] leading-relaxed">
                {t(`coursesAdvanced.hotelTraining.${index}.text`)}
              </p>
            </div>
          ))}
        </div>

        {/* Note */}
        {String(t('coursesAdvanced.hotelTraining.note')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.04em] mt-8 text-center">{__s}</p>))}
      </div>
    </section>
  );
}
